
import React, { useState, useEffect } from 'react';
import RoundResultRow from '../RoundResultRow';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

const normalizeDisplayCount = (displayCount) => {
  if (displayCount === undefined || displayCount === null || displayCount === '') {
    return null;
  }

  const numericCount = Number(displayCount);
  if (!Number.isFinite(numericCount) || numericCount <= 0) {
    return null;
  }

  return Math.floor(numericCount);
};

const getRowUserId = (row) => row?.user_id ?? row?.userId ?? row?.id;

export const getDisplayedRows = ({
  rows,
  displayMode,
  displayCount,
  currentUserId,
}) => {
  const sourceRows = Array.isArray(rows) ? rows : [];
  const count = normalizeDisplayCount(displayCount);

  if (!count) {
    return sourceRows.slice();
  }

  if (sourceRows.length <= count) {
    return sourceRows.slice();
  }

  const mode = displayMode || 'top';
  if (mode === 'aroundMe') {
    const currentIndex = sourceRows.findIndex((row) => {
      const rowUserId = getRowUserId(row);
      return rowUserId !== undefined &&
        rowUserId !== null &&
        currentUserId !== undefined &&
        currentUserId !== null &&
        String(rowUserId) === String(currentUserId);
    });

    if (currentIndex !== -1) {
      const beforeCount = Math.floor((count - 1) / 2);
      let start = currentIndex - beforeCount;
      start = Math.max(0, Math.min(start, sourceRows.length - count));
      return sourceRows.slice(start, start + count);
    }
  }

  return sourceRows.slice(0, count);
};

function RoundResultTable({ dialogDatas, displayMode, displayCount, currentUserId }) {
  const [userDatas, setUserDatas] = useState(null);

  useEffect(() => {
    if (dialogDatas && dialogDatas.result && dialogDatas.result.event_users) {
      setUserDatas(dialogDatas.result.event_users);
    }
  }, [dialogDatas]);

  const headerCellStyle = {
    writingMode: 'vertical-rl',
    textOrientation: 'upright',
    fontSize: '12px',
    fontWeight: 'bold',
    color: '#444',
    padding: '6px 8px',
    textAlign: 'center',
    lineHeight: '1.4',
    borderBottom: '2px solid #ccc',
    backgroundColor: '#f5f5f5',
  };
  const displayedRows = getDisplayedRows({
    rows: userDatas,
    displayMode,
    displayCount,
    currentUserId,
  });

  if (userDatas) {
    return (
      <TableContainer
        component={Paper}
        style={{
          margin: '24px auto',
          borderRadius: '8px',
          boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
          maxWidth: '600px',
          width: '100%',
          overflowX: 'auto',
        }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{ ...headerCellStyle, width: '40px' }}>順位</TableCell>
              <TableCell style={{ ...headerCellStyle, minWidth: '80px' }}>名前</TableCell>
              <TableCell style={{ ...headerCellStyle, width: '50px' }}>ラウンド収支</TableCell>
              <TableCell style={{ ...headerCellStyle, width: '50px' }}>累計収支</TableCell>
              <TableCell style={{ ...headerCellStyle, width: '50px' }}>変動</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {displayedRows.map((tableUser) => (
              <RoundResultRow
                isCurrentUser={String(getRowUserId(tableUser)) === String(currentUserId)}
                user={tableUser}
                index={userDatas.indexOf(tableUser)}
                key={tableUser.user_id}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }
  return null;
}

export default RoundResultTable;
